import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthStore } from '@features/auth/types/authStore';
import { decodeJwt } from '@infrastructure/jwt/decode/jwtDecoder';
import { createAuthUser } from '@features/auth/types/authUser';


export const useAuthStore = create<AuthStore>()(
    persist(
      (set, get)  => ({
        accessToken: null as string | null,
        setAccessToken: (t) => set({ accessToken: t }),
        clearAccessToken: () => set({ accessToken: null }),
        logout: () => set({ accessToken: null }),
        getAuthUser: () => {
            const accessToken = get().getAccessToken();
            if (!accessToken) return null;
            const decodedToken = decodeJwt(accessToken);
            return createAuthUser(decodedToken);
        },
        getAccessToken: () => {
            const accessToken = get().accessToken;
            return accessToken ? accessToken : null;
        },
        isAuthenticated: () => {
            const accessToken = get().getAccessToken();
            if (!accessToken) return false;
            const decodedToken = decodeJwt(accessToken);
            return decodedToken.exp && decodedToken.exp > (Date.now() / 1000) + 600 ? true : false;
        },
      }),
      {
        name: 'access-token',
        version: 1,
      }
    )
  );
